/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const pieChartData = {
    labels: ['Facebook', 'Direct', 'Organic', 'Referral'],
    datasets: {
        label: 'Projects',
        backgroundColors: ['info', 'primary', 'dark', 'secondary', 'primary'],
        data: [15, 20, 12, 60],
    },
};

export default pieChartData;
